import type {
  DeviceGroupAttribute,
  GraphLayoutRequest,
  GraphPath,
} from '@ipfabric/utils';
import type { DeviceGroupAttributePathLayouts } from 'components/Graph/GraphState';
import { applyTopologySettings } from 'components/Graph/commands/applyTopologySettings';
import { loadGraph } from 'components/Graph/commands/loadGraph';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { array, option } from 'fp-ts';
import { pipe } from 'fp-ts/lib/function';

interface SubmitTopologyInputCommand {
  groupBy: DeviceGroupAttribute;
  paths: Set<GraphPath>;
}

const getChangedLayoutPaths = (
  paths: GraphPath[],
  defaultPathLayouts: DeviceGroupAttributePathLayouts,
  pathLayouts: DeviceGroupAttributePathLayouts,
): GraphLayoutRequest[] =>
  pipe(
    paths,
    array.filterMap((path) => {
      const layout = pathLayouts[path];
      return layout !== undefined && defaultPathLayouts[path] !== layout
        ? option.some({
            path,
            layout,
          })
        : option.none;
    }),
  );

export const submitTopologyInput: GraphCommandFactory<
  SubmitTopologyInputCommand
> = (cmdContext, dispatch) => async (command) => {
  dispatch(applyTopologySettings, { fetchDataDisabled: true });
  const { groupBy } = command;
  const paths = Array.from(command.paths.values());
  const changedLayouts = getChangedLayoutPaths(
    paths,
    cmdContext.getState().defaultPathLayouts[groupBy],
    cmdContext.getState().pathLayouts[groupBy],
  );

  await dispatch(loadGraph, {
    overlay: 'keep',
    parameters: {
      groupBy,
      layouts: changedLayouts,
      paths,
      technologies: cmdContext.getState().technologies.selectedTechnologies,
      type: 'topology',
    },
  });
};
